import { useEffect, useState } from "react";
import { getInteresInvoice } from "../../../lib/getInteresInvoice";

const InteresByInvoice = ({ period, setInterestInvoice }) => {
  const [interestInvoice, setLocalInterestInvoice] = useState(0);
debugger
  useEffect(() => {
    if (period && period.length === 2) {
      fetchInteresInvoice(period);
    } else {
      setLocalInterestInvoice(null);
      setInterestInvoice(null); // Reiniciar si `period` no es válido
    }
  }, [period]);

  async function fetchInteresInvoice(period) {
    try {
      // Usar period[1] que es la fecha de fin del período facturado
      // El cálculo de intereses debe ser desde el mes siguiente al fin del período hasta el mes actual
      const interesInvoiceTotal = await getInteresInvoice(period[1]);
      if (interesInvoiceTotal?.data?.interestTotal) {
        // Parse to float and restrict to 2 decimals
        const interestValue = parseFloat(interesInvoiceTotal.data.interestTotal).toFixed(2);
        setLocalInterestInvoice(interestValue);
        setInterestInvoice(interestValue); // Actualizar el interés en `ModalGenerateInvoice`
      } else {
        setLocalInterestInvoice(0);
        setInterestInvoice(0);
      }
    } catch (error) {
      console.error("Error fetching interest invoice:", error);
      setLocalInterestInvoice(0);
      setInterestInvoice(0); // Establecer a 0 en caso de error
    }
  }

  return (
    <div  style={{
      fontSize:"15px", 
      marginTop:"20px"
    }}>
      <span style={{
      fontWeight:"bold"
    }}>Interés Total Acumulado:</span>{" "}
      {interestInvoice !== null ? `${interestInvoice}%` : "Selecciona un período"}
      <div style={{
      color:"#bbb"
    }}><small>Este interés será aplicado a su factura. Es el interés mensual acumulado a la fecha de facturacion - no incluye intereses del mes actual.</small></div>
    </div>
  );
};

export default InteresByInvoice;
